import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { SwitchingTitle, ReviewsIOWidget, LinearProgressWithTitleAndLabel } from '@ruby-labs/ui-core-kit';

import { pageConfiguration } from 'containers/index';

import { ModalContent, PopupData } from 'pages/plan-loader/modal-content';
import { planLoaderData } from 'pages/plan-loader/plan-loader-data';

import { ModalWindow } from 'components/modal-window';
import { Typography } from 'components/typography';

import { TypographyVariants } from 'constants/typography-variants';
import { LOADER_COLORS, MAX_PERCENTS } from 'constants/plan-loader';
import { ABLE_STORE } from 'constants/able-store';

import logoBlack from 'assets/images/svg/logo-black.svg';

import { useStyles } from './styles';

export const PlanLoader = () => {
    const { t } = useTranslation();

    const { pageWrapper, pageContent, pageTitle, loaderWrapper, modalWindow } = useStyles();

    const [activeBar, setActiveBar] = useState(0);
    const [percents, setPercents] = useState(planLoaderData.map(() => 0));
    const [step, setStep] = useState<number>(0);
    const [activeProgress, toggleActiveProgress] = useState(true);

    useEffect(() => {
        let interval: ReturnType<typeof setInterval> | undefined = undefined;

        if (activeProgress) {
            clearInterval(interval);

            const { titles } = planLoaderData[activeBar];

            const { time } = titles[step];

            interval = setInterval(() => {
                if (percents[activeBar] === MAX_PERCENTS) {

                    if (activeBar === planLoaderData.length - 1) {
                        clearInterval(interval);

                        return;
                    }

                    setActiveBar(activeBar + 1);

                    return;
                }

                percents[activeBar]++;

                if (percents[activeBar] === titles[step].range[1] && [2,3].includes(titles.length)) {
                    setStep((step + 1) % titles.length);
                }

                setPercents([...percents]);

                if (percents[activeBar] === planLoaderData[activeBar].popUpTime) {
                    toggleActiveProgress(false);
                }

                if (percents[planLoaderData.length - 1] === MAX_PERCENTS) {
                    pageConfiguration.handleOnPageComplete();
                }

            }, time / (titles[step].range[1] - titles[step].range[0]));

        } else {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [activeBar, activeProgress, percents]);

    const {
        bodyColor,
        bodyColorCheckIconPathFill,
        habitColor,
        habitColorCheckIconPathFill,
        nutritionColor,
        nutritionColorCheckIconPathFill,
    } = LOADER_COLORS;

    return (
        <div className={pageWrapper}>
            <div className={pageContent}>
                <img src={logoBlack} alt='Medication Lose Weight Logo' />
                <Typography variant={TypographyVariants.h1} typographyNext className={pageTitle}>
                    <Trans i18nKey='plan-loader-title' />
                </Typography>
                <div className={loaderWrapper}>
                    <SwitchingTitle
                        titles={planLoaderData[activeBar].titles
                            .map(title => ({
                                ...title,
                                value: t(title.value)
                            }))
                        }
                        percents={percents[activeBar]}
                    />
                    <LinearProgressWithTitleAndLabel
                        percents={percents[0]}
                        title={t('plan-loader-thin-loading-bar-with-title-and-checkbox-body-parameters-title')}
                        color={bodyColor}
                        labelBg={bodyColorCheckIconPathFill}
                    />
                    <LinearProgressWithTitleAndLabel
                        percents={percents[1]}
                        title={t('plan-loader-thin-loading-bar-with-title-and-checkbox-motivation-and-psychology-title')}
                        color={habitColor}
                        labelBg={habitColorCheckIconPathFill}
                    />
                    <LinearProgressWithTitleAndLabel
                        percents={percents[2]}
                        title={t('plan-loader-thin-loading-bar-with-title-and-checkbox-medical-conditions-title')}
                        color={nutritionColor}
                        labelBg={nutritionColorCheckIconPathFill}
                    />
                </div>
            </div>

            {!activeProgress && planLoaderData[activeBar].popUpData && (
                <ModalWindow modalWindowFormClassName={modalWindow} hasCloseIcon={false}>
                    <ModalContent
                        onChosen={() => toggleActiveProgress(true)}
                        data={planLoaderData[activeBar].popUpData as PopupData}
                    />
                </ModalWindow>
            )}

            <ReviewsIOWidget store={ABLE_STORE} />
        </div>
    );
};
